import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {CommonRzmService} from './common-rzm.service';
import {RestEndPoints} from '../model/RestEndPoints';
import {ErrorVO} from '../generate/ErrorVO';
import {NameServerVO, TopLevelDomainVO, TrustAnchorVO} from '../generate/TopLevelDomainVO';
import {AuthService} from './auth.service';
import {OrganizationVO} from '../generate/OrganizationVO';
import {ContactVO} from '../generate/ContactVO';

@Injectable()
export class ValidatorService extends CommonRzmService {

  constructor(@Inject(HttpClient) http , @Inject('env') environment, @Inject(AuthService) auth) {
    super(http, environment, auth);
  }

  validateSOContact(organization: OrganizationVO): Observable<ErrorVO> {
    const url = this.getRestEndPoint() + RestEndPoints.VALIDATE_SPONSORINGORG;
    return this.getPostResponse(url, organization);
  }

  validateContactInfo(contact: ContactVO): Observable<ErrorVO> {
    const url = this.getRestEndPoint() + RestEndPoints.VALIDATE_CONTACT_INFO;
    return this.getPostResponse(url, contact);
  }

  validateNameServers(nameServers: Array<NameServerVO>): Observable<ErrorVO> {
    const url = this.getRestEndPoint() + RestEndPoints.VALIDATE_NAMESERVERS;
    return this.getPostResponse(url, nameServers);
  }

  validateTrustAnchors(trustAnchors: Array<TrustAnchorVO>): Observable<ErrorVO> {
    const url = this.getRestEndPoint() + RestEndPoints.VALIDATE_TRUST_ANCHORS;
    return this.getPostResponse(url, trustAnchors);
  }

  validateAdditionalInfo(originalTld: TopLevelDomainVO, tld: TopLevelDomainVO): Observable<ErrorVO> {
    const url = this.getRestEndPoint() + RestEndPoints.VALIDATE_ADDITIONAL_INFO;
    return this.getPostResponse(url, {
      originalTld: originalTld,
      proposedTld: tld
    });
  }
}
